import { Link, Text, VStack } from '@ayble-health/dashboard-components';
import { useParams } from 'react-router-dom';
import { useUserMeetings } from '../../api/healthCoach/useUserMeetings';
import { Box } from '@chakra-ui/react';
import { Accordions } from '../Form/Accordions';
import { Loader } from '../Loader';
import { MeetingHeader } from './MeetingHeader';

export const MeetingNotes = ({ onOpenChartNote }) => {
  const { patient } = useParams();
  const { meetings, isLoading, isError } = useUserMeetings(patient ?? '');

  if (isLoading) {
    return (
      <Box p={0}>
        <Loader loading={true} />
      </Box>
    );
  }

  return (
    <VStack>
      <Text
        color={'blueGray.600'}
        fontSize={'md'}
        fontWeight={'normal'}
        textAlign="left"
      >
        Meeting &amp; Billing History
      </Text>

      {isError && (
        <Text mb={6} fontSize={'sm'} color={'error.600'}>
          An error occurred while trying to load or save the meeting notes:
          please refresh the page and try again.
        </Text>
      )}

      {!meetings?.length && (
        <Text fontSize={'sm'} italic py={3}>
          No meetings for this user
        </Text>
      )}

      {!!meetings?.length && (
        <Accordions
          content={(item) => (
            <VStack pl={5} pr={7}>
              <Text fontSize={'md'}>
                Meeting Type: {item.meeting_type}
                <br></br>
                Provider: {item?.provider?.display_name}
                <br></br>
                User confirmed? {item?.client_confirmed ? 'Yes' : 'No'}
                <br></br>
                Rescheduled count: {item.rescheduled_count ?? "0"}
                <br></br>
                Late rescheduled count: {item.late_rescheduled_count ?? "0"}
                <br></br>
                Charting Notes:
                {item?.chart_notes?.map(({ note_type, note_url }, i) => (
                  <Box key={i} w={'100%'}>
                    <Text fontSize={'sm'}>
                      {'\u2022'}{' '}
                      {note_url ? (
                        <Link
                          onPress={() => onOpenChartNote(note_url)}
                          _text={{ textTransform: null }}
                        >
                          {note_type}
                        </Link>
                      ) : (
                        <Text>{note_type}</Text>
                      )}
                    </Text>
                  </Box>
                ))}
              </Text>
            </VStack>
          )}
          header={(item) => <MeetingHeader item={item} />}
          items={meetings}
        />
      )}
    </VStack>
  );
};
